import React, { useState } from "react";
import Mockup from "../assets/ipad2.png";
import { FaArrowRight, FaStar } from "react-icons/fa";
import { MdMonitor } from "react-icons/md";
import "../styles/Banner.css";

function Banner() {
  const [rotation, setRotation] = useState({ x: 0, y: 0 });

  const handleMouseMove = (e) => {
    const wrapper = e.currentTarget;
    const rect = wrapper.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    const rotateY = (x / rect.width - 0.5) * 40;
    const rotateX = (y / rect.height - 0.5) * -40;

    setRotation({ x: rotateX, y: rotateY });
  };

  const handleMouseLeave = () => {
    setRotation({ x: 0, y: 0 });
  };

  return (
    <section className="banner-section">
      <div className="banner-glow"></div>

      <div className="banner-content">
        <div className="text-content">
          <div className="badge">
            <FaStar style={{ color: "#fac852" }} /> Lançamento 2025
          </div>
          <h1>
            A <span className="highlight">Inteligência Artificial</span> que
            revoluciona a gestão do seu consultório
          </h1>
          <p>
            Simplifique sua gestão clínica com IA avançada. Automatize
            agendamentos, controle financeiro e relatórios em uma única
            plataforma intuitiva.
          </p>
          <div className="button-group">
            <button className="btn primary">
              30 dias GRÁTIS <FaArrowRight size={16} />
            </button>
            <button className="btn secondary">
              Conheça o ARC <MdMonitor size={18} />
            </button>
          </div>
        </div>

        <div
          className="mockup-wrapper"
          onMouseMove={handleMouseMove}
          onMouseLeave={handleMouseLeave}
        >
          <img
            src={Mockup}
            alt="Mockup ARC"
            className="ipad-mockup"
            style={{
              transform: `rotateX(${rotation.x}deg) rotateY(${rotation.y}deg) scale(1.02)`,
            }}
          />
        </div>
      </div>
    </section>
  );
}

export default Banner;
